// HOCS
export {
    default as onboardingPrompt,
} from 'contest/components/onboarding-prompts/onboardingPrompt';
export {
    default as onboardingInfoBox,
} from 'contest/components/onboarding-prompts/onboardingInfoBox';
export {
    default as contestStageSelector,
} from 'contest/components/onboarding-prompts/contestStageSelector';

// Prompts
export {
    default as NewDesignsInfoBox,
} from 'contest/components/onboarding-prompts/NewDesignsInfoBox';
export {
    default as GoodDesignsInfoBox,
} from 'contest/components/onboarding-prompts/GoodDesignsInfoBox';
export {
    default as BriefScoreInfoBox,
} from 'contest/components/onboarding-prompts/BriefScoreInfoBox';
export {
    default as FinalRoundInfoBox,
} from 'contest/components/onboarding-prompts/FinalRoundInfoBox';
export {
    default as FinalistButtonOnboardingPrompt,
} from 'contest/components/onboarding-prompts/FinalistButtonOnboardingPrompt';
export {
    default as PollsTabOnboardingPrompt,
} from 'contest/components/onboarding-prompts/PollsTabPrompt';
export {
    default as GroupByPotentialFinalistPrompt,
} from 'contest/components/onboarding-prompts/GroupByPotentialFinalistPrompt';



// WEBPACK FOOTER //
// ./src/web/js/contest/components/onboarding-prompts/index.js